export default __webpack_public_path__ + "static/media/ic_work.e14c92d2.svg";